import {httpPost,httpGet} from '@/common/js/util'
import {rootUrl} from '@/common/js/config'

const retryTimes = 3;
/*获取省份列表*/
export function getProvinceList() {
  let getProvinces = rootUrl.getProvinces
  return httpPost(getProvinces,{},retryTimes)
}
/*获取城市列表*/
export function getCityList(provinceId){
  let params = {"provinceId":provinceId}
  let getCityList = rootUrl.getCityList
  return httpPost(getCityList,params,retryTimes)
}
/*获取区县列表*/
export function getDistrictList(cityId){
  let params = {"cityId":cityId}
  let getDistrictList = rootUrl.getDistrictList
  return httpPost(getDistrictList,params,retryTimes)
}

/*获取区域平台的学校列表*/
export function getSchoolListByPlatFormId(params){
  let getSchoolListByPlatFormId = rootUrl.getSchoolListByPlatFormId
  return httpPost(getSchoolListByPlatFormId,params)
}

/*筛选获取中台创建的学校列表*/
export function getSchoolList(provinceId,cityId,districtId,schoolNameKey,pageNum = 1,pageSize = 10){
  let params = {
  	"provinceId":provinceId, 'cityId': cityId,
    'districtId':districtId,
    'schoolName':schoolNameKey,
    'pageNum': pageNum,
    'pageSize': pageSize
  }
  let getSchoolListByPlatFormId = rootUrl.getSchoolList
  return httpPost(getSchoolListByPlatFormId,params)
}

/*获取当前用户信息*/
export function getCurrentUserInfo(){
  return httpGet(rootUrl.getCurrentUser)
}

/*退出登录*/
export function logout(){
  let url = rootUrl.logout;
  return httpGet(url);
}


//获取应用分类
export function getAppCategory(){
  return httpPost(rootUrl.getAppCategoryByPage)
}

/* 获取api网关地址 */
export function getApiUrl(){
  return httpPost(rootUrl.getApiUrl)
}

/* 获取平台省市区信息 */
export function getPlatFormInfo(){
  return httpPost(rootUrl.getPlatFormInfo,{},retryTimes)
}

/* 获取应用概括信息 */
export function getAppApiConfig(params){
  return httpPost(rootUrl.getAppApiConfig,params,retryTimes)
}

/* 获取集团校 */
export function getGroupSchoolList(params){
  return httpPost(rootUrl.getGroupSchoolList,params,retryTimes)
}


/*  */
export function getExchangeMenuEnable(params={}){
  return httpPost(rootUrl.getExchangeMenuEnable,params,retryTimes)
}





// WEBPACK FOOTER //
// ./src/api/common-api.js